import React from "react";

import { PlayerProps, PlayerState } from "./models";

import { ContentType } from "commons/form-constants";

import Box from "@mui/material/Box";

import videojs from 'video.js';
import 'video.js/dist/video-js.css';

declare let bitmovin: any;

export class Player extends React.Component<PlayerProps, PlayerState> {

    private player: any;
    private videoNode: any;

    constructor(props: any) {

        super(props);

        this.state = {
            loaded: false
        };
    }

    componentDidMount() {

        switch (process.env.REACT_APP_PLAYER_VENDOR) {

            case "BITMOVIN": {

                let playerConfig = {
                    "key": process.env.REACT_APP_BITMOVIN_PLAYER_KEY || "",
                    "playback": {
                        "muted": false,
                        "autoplay": false
                    }
                }

                let container = document.getElementById('player');
                let player = new bitmovin.player.Player(container, playerConfig);

                let sourceConfig = {};

                if (this.props.content.type === ContentType.VOD && this.props.content.vodAdditionalInfos !== null) {
                    sourceConfig = {
                        "progressive": !this.props.content.vodAdditionalInfos.needsEncoding ? (process.env.REACT_APP_API_CLOUDFRONT_DISTRIBUTION_URL + this.props.content.vodAdditionalInfos.vodS3Key!) : undefined,
                        "hls": this.props.content.vodAdditionalInfos.needsEncoding ? (process.env.REACT_APP_API_CLOUDFRONT_DISTRIBUTION_URL + this.props.content.vodAdditionalInfos.encodedContentS3Key!) : undefined,
                        "poster": (process.env.REACT_APP_API_CLOUDFRONT_DISTRIBUTION_URL) + this.props.content.thumbnailData.thumbnailS3Key!
                    }
                }

                if (this.props.content.type === ContentType.LIVE && this.props.content.liveAdditionalInfos !== null) {
                    sourceConfig = {
                        "hls": this.props.content.liveAdditionalInfos.contentOutputUrl,
                        "poster": (process.env.REACT_APP_API_CLOUDFRONT_DISTRIBUTION_URL) + this.props.content.thumbnailData.thumbnailS3Key!
                    }
                }

                player.load(sourceConfig).then(function () {
                }).catch(function (reason: any): void {
                });

                break;
            }
            case "VIDEOJS": {

                let videoUrl: string = this.props.content.contentServingUrl;
                let contentType: string = "video/mp4"

                if (this.props.content.type === ContentType.VOD && this.props.content.vodAdditionalInfos !== null) {
                    contentType = "video/" + this.props.content.vodAdditionalInfos.format;
                    if (this.props.content.vodAdditionalInfos.needsEncoding)
                        contentType = "application/x-mpegURL"
                }


                if (this.props.content.type === ContentType.LIVE && this.props.content.liveAdditionalInfos !== null) {
                    contentType = "application/x-mpegURL"
                }


                let videoProps = {
                    autoplay: this.props.autoplay,
                    controls: true,
                    fluid: true,
                    poster: this.props.content.thumbnailServingUrl,
                    sources: [{
                        src: videoUrl,
                        type: contentType
                    }]
                }

                this.player = videojs(this.videoNode, videoProps, async () => { await this.parseVodAdditionalInfos() });

                break;
            }
        }
    }

    parseVodAdditionalInfos = async () => {

        let content = this.props.content;

        for (let subtitle of content.subtitles) {

            const srtText = await fetch(subtitle.subtitleServingUrl).then(response => response.text())
            const srtRegex = /(.*\n)?(\d\d:\d\d:\d\d),(\d\d\d --> \d\d:\d\d:\d\d),(\d\d\d)/g
            const vttText = 'WEBVTT\n\n' + srtText.replace(srtRegex, '$1$2.$3.$4');
            const vttBlob = new Blob([vttText], { type: 'text/vtt' });
            const vttBlobURL = URL.createObjectURL(vttBlob);
            this.player.addRemoteTextTrack({
                src: vttBlobURL,
                srclang: subtitle.language,
                label: subtitle.language,
                kind: 'subtitles',
            }, true)

        }
    }

    componentWillUnmount(): void {

        if (this.player) {
            this.player.dispose();
        }

    }

    render() {
        return (<Box>
            {process.env.REACT_APP_PLAYER_VENDOR === "BITMOVIN" && <Box component={"div"} id={'player'}></Box>}
            {process.env.REACT_APP_PLAYER_VENDOR === "VIDEOJS" && <Box component="div" data-vjs-player>
                <video ref={node => this.videoNode = node} className="video-js vjs-16-9 vjs-default-skin vjs-big-play-centered"></video>
            </Box>}
        </Box>)
    }
}
